import { BREAKPOINTS } from '../config';

const { mqTouch } = BREAKPOINTS;

document.querySelectorAll('.art-nav').forEach(sidebar => {
  initArtNav(sidebar);
});

function initArtNav(sidebar) {
  const header = document.querySelector('.header');
  const aside = sidebar.querySelector('.art-nav__aside');
  const navList = sidebar.querySelector('.art-nav__list');
  const content = sidebar.querySelector('.art-nav__content');

  if (!navList || !content) return;

  let titles = content.querySelectorAll('h2');
  if (!titles.length) titles = content.querySelectorAll('h3');
  if (!titles.length) return;

  const uid = Math.random().toString(36).slice(2, 7);

  titles.forEach((title, i) => {
    title.id = `art-nav-${uid}-${i + 1}`;
  });

  const isOrdered = navList.hasAttribute('data-ol');
  const nav = document.createElement(isOrdered ? 'ol' : 'ul');
  nav.className = 'art-nav__nav';

  titles.forEach((title, i) => {
    const li = document.createElement('li');
    const a = document.createElement('a');

    a.href = `#art-nav-${uid}-${i + 1}`;

    const titleText = title.textContent.trim();
    const hasNumbering = /^\d+\.?\s/.test(titleText);

    if (isOrdered) {
      if (hasNumbering) {
        a.textContent = titleText;
      } else {
        const num = String(i + 1).padStart(2, '0');
        a.textContent = `${num}. ${titleText}`;
      }
    } else {
      a.textContent = title.textContent;
    }

    if (i === 0) a.classList.add('is-active');

    li.appendChild(a);
    nav.appendChild(li);
  });

  navList.innerHTML = '';
  navList.appendChild(nav);

  const links = [...nav.querySelectorAll('a')];
  const anchors = titles;

  function getMetrics() {
    const scrollTop = window.scrollY;
    const headerHeight = header?.offsetHeight || 0;
    const navListHeight = navList.offsetHeight || 0;
    const stickyTop = parseFloat(getComputedStyle(aside).top) || 0;

    return { scrollTop, headerHeight, navListHeight, stickyTop };
  }

  function getAnchorTop(anchor) {
    return Math.round(anchor.getBoundingClientRect().top + window.scrollY);
  }

  let currentActive = links[0];

  function setActiveLink() {
    const { scrollTop, headerHeight, navListHeight, stickyTop } = getMetrics();

    let trigger = scrollTop + headerHeight + stickyTop + 16;

    if (window.innerWidth <= mqTouch) trigger += navListHeight;

    let next = links[0];

    anchors.forEach((anchor, i) => {
      if (getAnchorTop(anchor) <= trigger) {
        next = links[i];
      }
    });

    if (next === currentActive) return;

    currentActive?.classList.remove('is-active');
    next.classList.add('is-active');
    currentActive = next;

    scrollNavToActive(next);
  }

  function scrollNavToActive(link) {
    const isHorizontal = window.innerWidth <= mqTouch;
    const rect = link.getBoundingClientRect();
    const listRect = navList.getBoundingClientRect();

    if (isHorizontal) {
      const offset =
        rect.left - listRect.left - listRect.width / 2 + rect.width / 2;
      navList.scrollBy({ left: offset, behavior: 'smooth' });
    } else {
      const offset =
        rect.top - listRect.top - listRect.height / 2 + rect.height / 2;
      navList.scrollBy({ top: offset, behavior: 'smooth' });
    }
  }

  nav.addEventListener('click', e => {
    const a = e.target.closest('a');
    if (!a) return;

    e.preventDefault();

    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;

    const { headerHeight, navListHeight, stickyTop } = getMetrics();

    let scrollToY = getAnchorTop(target) - headerHeight - stickyTop;

    if (window.innerWidth <= mqTouch) scrollToY -= navListHeight;

    window.scrollTo({ top: scrollToY, behavior: 'smooth' });
  });

  requestAnimationFrame(() => {
    setActiveLink();
    window.addEventListener('scroll', setActiveLink, { passive: true });
  });
}

// <section class="art-nav">
//   <div class="__container">
//     <div class="__body">
//       <aside class="art-nav__aside">
//         <div class="art-nav__list" data-ol></div>
//       </aside>
//       <div class="art-nav__content"></div>
//     </div>
//   </div>
// </section>;
